export default __webpack_public_path__ + "static/media/RAIDER 125_1.16b05fe5.webp";